import { brand } from "../config/brand";
import { useI18n } from "../features/i18n/I18nProvider";

export function BrandedLoadingScreen() {
  const { locale } = useI18n();
  return (
    <div className="brand-loading-screen" role="status" aria-live="polite">
      <div className="brand-loading-mark" aria-hidden="true">
        <span className="has-logo">
          <img
            src="/brand/favicon-192.png"
            alt=""
            width="192"
            height="192"
            decoding="sync"
            fetchPriority="high"
          />
        </span>
        <i />
      </div>
      <strong>{brand.name}</strong>
      <p>{locale === "gn-PY" ? "Jaikuaave Piribebuy..." : "Explorando Piribebuy..."}</p>
    </div>
  );
}

